import { useSteps } from '@chakra-ui/react';
import React, { ReactNode, useCallback, useContext, useEffect } from 'react';

type StepperContextValue = {
  steps: string[];
	activeStep: number;
	//currentStep: number;
	//setActiveStep: Dispatch<SetStateAction<number>>;
	nextStep: () => void;
	previousStep: () => void;
}

interface StepperProviderProps {
  steps: string[];
  activeStepIndex?: number;
	children?: ReactNode;
}

const StepperContext = React.createContext<StepperContextValue | undefined>(
	undefined,
);

export const useStepperContext = () => {
	const value = useContext(StepperContext);
	if (value === undefined) {
		throw Error('useStepperContext can not be used outside a StepperProvider');
	}
	return value;
};

export default function StepperProvider({ steps, activeStepIndex, children }: StepperProviderProps) {
	const { activeStep, setActiveStep } = useSteps({
    index: activeStepIndex || 0,
    count: steps.length,
  });

	useEffect(() => {
		if (activeStepIndex !== undefined)
			setActiveStep(activeStepIndex)
	}, [activeStepIndex, setActiveStep])

	const goToStep = useCallback((step: number) => {
		if (step < steps.length && step >= 0) {
			setActiveStep(step);
		}
	}, [setActiveStep, steps]);

	const nextStep = useCallback(() => goToStep(activeStep + 1), [activeStep, goToStep]);
	const previousStep = useCallback(() => goToStep(activeStep - 1), [activeStep, goToStep]);

	const value = { steps, activeStep, setActiveStep, nextStep, previousStep };
	
	return (
		<StepperContext.Provider
			value={value}>
			{children}
		</StepperContext.Provider>
	);
}